import { ValuesMap } from '../types/ValuesMap';

export const toValuesMap = <V extends unknown>(values: V[]): ValuesMap<V> => {
  return Object.fromEntries(values.map((value) => [value, true]));
};
